import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  Suspense,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { DeleteArticle } from "./Services/ArticleDiscussionBoardService";
import { getArticle } from "./Services/ArticleDiscussionBoardService";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import { TostMsg } from "../../../App";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { InputSwitch } from "primereact/inputswitch";
import debounce from "lodash.debounce";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

function ArticleDiscussionBoard() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [articleList, setArticleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [articleDeleteId, setArticleDeleteId] = useState(0);
  const [articleHeading, setArticleHeading] = useState("");
  const [articleHeadingDesc, setArticleHeadingDesc] = useState("");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [deleteContent, setDeleteContent] = useState([]);
  const toster = useContext(TostMsg);
  const [page, setPage] = useState(1);
  const [showArticleDataNotFound, setShowArticleDataNotFound] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [IsArchived, setIsArchived] = useState(false);
  const [IsFeatured, setIsFeatured] = useState(false);
  const [selectedArticleByName, setSelectedArticleByName] = useState(null);
  const [selectedArticlePostedByName, setSelectedArticlePostedByName] =
    useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  const [userDeletePermission, setUserDeletePermission] = useState(false);
  const [userEditPermission, setUserEditPermission] = useState(false);
  const [articleIsArchive, setArticleIsArchive] = useState(false);
  const [articleIsFeature, setArticleIsFeature] = useState(false);
  const [noData, setNoData] = useState([]);
  const observer = useRef();
  let history = useHistory();
  let searchValue = "";
  useEffect(() => {
    GetMasterSystemAlertList("Article_heading", 2);
    GetMasterSystemAlertList("Article_heading_desc", 3);
    GetMasterSystemAlertList("Aticle_Unavailable", 4);
    GetArticleList(page, searchValue, IsArchived, IsFeatured);
    fetchEmployeeIdData();
    permissionArticleAdd();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (page > 1 && !articleDeleteId) {
      GetArticleList(page, searchValue, IsArchived, IsFeatured);
    }
  }, [page]);

  useEffect(() => {
    if (selectedArticleByName) {
      GetArticleList(1, searchValue, IsArchived, IsFeatured);
    } else if (selectedArticlePostedByName) {
      GetArticleList(1, searchValue, IsArchived, IsFeatured);
    }
  }, [selectedArticleByName, selectedArticlePostedByName]);

  const permissionArticleAdd = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Add Article") {
        setUserUpdatePermission(true);
      } else if (UserPermission.PermissionName == "Delete Article") {
        setUserDeletePermission(true);
      } else if (UserPermission.PermissionName == "Edit Article") {
        setUserEditPermission(true);
      } else if (UserPermission.PermissionName == "ArticleIsArchive Read") {
        setArticleIsArchive(true);
      } else if (UserPermission.PermissionName == "ArticleIsFeature Read") {
        setArticleIsFeature(true);
      }
    });
  };

  async function GetArticleList(page, searchValue, IsArchived, IsFeatured) {
    setLoading(true);
    const params = {
      LoggedInUserId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
      articleByGUID: "",
      articleId: 0,
      Search: searchValue,
      articleById: selectedArticleByName?.EmpId ?? 0,
      IsFeatured: IsFeatured ? 1 : 0,
      IsArchived: IsArchived ? 1 : 0,
      PageNumber: searchValue ? 1 : page,
      postedById: selectedArticlePostedByName?.EmpId ?? 0,
      PageSize: 10,
    };
    try {
      const response = await getArticle(params);
      const ArticleData = response?.Data?.orgArticles || [];
      setLoading(false);

      if (
        searchValue ||
        selectedArticleByName?.EmpId ||
        IsFeatured ||
        IsArchived ||
        selectedArticlePostedByName?.EmpId ||
        articleDeleteId
      ) {
        setArticleList(ArticleData);
        setHasMore(false);
        if (ArticleData.length === 0) {
          setShowArticleDataNotFound(true);
          setHasMore(false);
        } else {
          // setHasMore(true);   //For the correction.
        }
      } else if (ArticleData.length === 0) {
        setShowArticleDataNotFound(true);
        setHasMore(false);
      } else {
        // setArticleList((prevArticle) => [...prevArticle, ...ArticleData]);
        setArticleList((prevArticle) => {
          const combinedMap = new Map();
          [...prevArticle, ...ArticleData].forEach((article) => {
            combinedMap.set(article.Id, article);
          });
          return Array.from(combinedMap.values());
        });
        setHasMore(ArticleData.length > 0);
      }
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.ArticleData);
    }
  }

  // getMasterSystemAlert...
  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setDeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setArticleHeading(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setArticleHeadingDesc(msg?.Desc);
      } else if (msg?.Name == message && type == 4) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  async function deleteArticleDetails() {
    if (articleDeleteId) {
      let body = {
        Id: articleDeleteId,
        EmpId: userDetails?.EmpId,
      };
      try {
        setLoading(true);
        let articleList = await DeleteArticle(body);
        if (articleList) {
          GetArticleList(1, searchValue, IsArchived, IsFeatured);
          setLoading(false);
          document.getElementById("delete-ed").click();
          GetMasterSystemAlertList("Article_Deleted", 0);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setLoading(false);
      }
    }
  }

  const TitleDetailId = (event) => {
    const Archived = event?.IsArchived == false ? 0 : 1;
    history.push(`/Article/Detail/${event?.GUID}/${Archived}`);
  };

  const goToEditPage = (event) => {
    const Archived = event?.IsArchived == false ? 0 : 1;
    history.push(`/Artical/Edit/${event?.GUID}/${Archived}`);
  };

  const handleInputChange = (event) => {
    handleSearch(event.target.value);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      // setSearchTerm(value);
      GetArticleList(1, value, IsArchived, IsFeatured);
    }, 800),
    [IsArchived, IsFeatured]
  );

  const lastAwardElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  async function fetchEmployeeIdData() {
    setLoading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const handleInputChangeIsArchived = (e) => {
    // if (!IsArchived) {
    //   GetMasterSystemAlertList("Is_Archived", 0);
    // }
    setPage(1);
    setHasMore(false);
    setIsArchived(e.value);
    GetArticleList(1, searchValue, e.value, IsFeatured);
  };

  const handleInputChangeIsFeatured = (e) => {
    // if (!IsFeatured) {
    //   GetMasterSystemAlertList("Is_Featured", 0);
    // }
    setPage(1);
    setHasMore(false);
    setIsFeatured(e.value);
    GetArticleList(1, searchValue, IsArchived, e.value);
  };

  const handleInputChangePostedByName = (e) => {
    const { name, value } = e.target;
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  return (
    <div>
      <div className="container-fluid   position-relation">
        <div className="row  g-4">
          <div className="form-head flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">{T(`${articleHeading}`)}</h2>
              <p className="text-light">{articleHeadingDesc}</p>
            </div>
          </div>
          <div className="article-filters">
            <span className="filter"> </span>
            <div className="actionbutton-tickets artical">
              <InputText
                name="requestTitle"
                className="form-control mr-2"
                placeholder="Search"
                onChange={handleInputChange}
              />
              <div className="d-flex d-flexx">
                <Dropdown
                  name="ArticleByName"
                  className="w-full md:w-14rem"
                  value={selectedArticleByName}
                  onChange={(e) => {
                    setSelectedArticleByName(e.value);
                    handleInputChangePostedByName(e);
                  }}
                  options={employeDetails?.toSpliced(0, 0, {
                    id: 0,
                    FullName: "All",
                  })}
                  itemTemplate={employeeOptionTemplate}
                  filter
                  optionLabel="FullName"
                  placeholder="Article By"
                />
              </div>
              <div className="d-flex d-flexx">
                <Dropdown
                  name="ArticleByName"
                  className="w-full md:w-14rem"
                  value={selectedArticlePostedByName}
                  onChange={(e) => {
                    setSelectedArticlePostedByName(e.value);
                  }}
                  options={employeDetails?.toSpliced(0, 0, {
                    id: 0,
                    FullName: "All",
                  })}
                  itemTemplate={employeeOptionTemplate}
                  filter
                  optionLabel="FullName"
                  placeholder="Posted By"
                />
              </div>
              {articleIsArchive && (
                <div className="me-2 select-futurepost-article">
                  <label>{IsArchived ? "Archived" : "Archived"}</label>
                  <div className="ml-auto d-flex">
                    <InputSwitch
                      checked={IsArchived}
                      onChange={(e) => handleInputChangeIsArchived(e)}
                    />
                  </div>
                </div>
              )}
              {articleIsFeature && (
                <div className="me-2 select-futurepost-article">
                  <label>{IsFeatured ? "Featured" : "Featured"}</label>
                  <div className="ml-auto d-flex">
                    <InputSwitch
                      checked={IsFeatured}
                      onChange={(e) => handleInputChangeIsFeatured(e)}
                    />
                  </div>
                </div>
              )}
              {userUpdatePermission && (
                <Link to="/Artical/Add">
                  <div className="org-add">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                  </div>
                </Link>
              )}
            </div>
          </div>
          <div>
            <div className="row g-3 mb-4 mt-3">
              {articleList?.map((article, index) => {
                const isLastElement = index === articleList?.length - 1;
                return (
                  <div
                    className="col-xl-4"
                    key={index}
                    ref={isLastElement ? lastAwardElementRef : null}
                  >
                    <div className="card article-card">
                      <div className="card-body mb-0 article-div-list">
                        <div
                          className="name"
                          style={{ cursor: "pointer" }}
                          onClick={() => TitleDetailId(article)}
                        >
                          <h5 className="mb-0">
                            {article?.Title?.length >= 25
                              ? `${article.Title.substring(0, 25)}...`
                              : article?.Title}
                          </h5>
                          <p className="article-morecontent two-line-text">
                            {article?.Summary?.length >= 150 ? (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: article?.Summary.substring(0, 150),
                                }}
                              />
                            ) : (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: article?.Summary,
                                }}
                              />
                            )}
                          </p>
                          <div className="writtenby d-flex align-items-center mt-3">
                            <div className="image">
                              <LazyImage
                                src={article?.ArticleByProfileImage}
                                width="100%"
                              />
                            </div>
                            <p
                              style={{
                                lineHeight: "1.3",
                                marginBottom: "0",
                                fontWeight: "600",
                                color: "black",
                              }}
                            >
                              <span>Written by</span>
                              {article?.ArticleByName}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer article-div-list2">
                        <strong className="announced-by">
                          <p>
                            <img src="/images/policy/date.svg" />
                            {moment(article?.ModifiedDate).format(
                              "MMM DD YYYY"
                            )}
                          </p>
                        </strong>
                        <div className="likes d-flex align-items-center ml-auto">
                          <a
                            onClick={() => TitleDetailId(article)}
                            style={{ cursor: "pointer" }}
                          >
                            {article?.IsLikedByMe == 1 && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                fill="currentColor"
                                className="bi bi-heart-fill text-danger"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                />
                              </svg>
                            )}
                            {article?.IsLikedByMe == 0 && (
                              <a className="like-button">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="bi bi-heart"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                                </svg>

                                <span className="like-overlay"></span>
                              </a>
                            )}
                            {article?.ArticleLikecount > 0 && (
                              <span>{article?.ArticleLikecount}</span>
                            )}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-chat-right-dots-fill"
                              viewBox="0 0 16 16"
                              style={{ color: "#0c357d", marginLeft: "0.5rem" }}
                            >
                              <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                            </svg>
                            {article?.ArticleCommentCount > 0 && (
                              <span>{article?.ArticleCommentCount}</span>
                            )}
                          </a>
                        </div>
                        <div className="action-btns">
                          {userEditPermission && (
                            <span
                              className="me-2 edit "
                              data-toggle="tooltip"
                              data-placement="top"
                              onClick={() => goToEditPage(article)}
                            >
                              <img
                                src="/images/tickets/edit-ico.svg"
                                className="editdivinfo"
                              />
                            </span>
                          )}
                          {userDeletePermission && (
                            <span
                              className="delete"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-ed"
                              title=""
                              data-bs-original-title="delete"
                              aria-label="delete"
                              onClick={() => {
                                setArticleDeleteId(article?.Id);
                                GetMasterSystemAlertList(
                                  "Article_Delete_Confirmation",
                                  1
                                );
                              }}
                            >
                              <img
                                src="/images/tickets/delete.svg"
                                className="editdivinfo"
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {showArticleDataNotFound === true &&
                articleList?.length === 0 && (
                  <div className="no-feedfound">
                    <img src="/images/default-award-Image.svg" />
                    <p>{noData}</p>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteArticleDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default ArticleDiscussionBoard;
